import { useContext, useState } from 'react'
import { BiPurchaseTagAlt } from 'react-icons/bi'
import { HiOutlineUpload } from 'react-icons/hi'
import { TbCoins } from 'react-icons/tb'
import { useQuery } from 'react-query'
import { ModalTotalContext } from '../../context/ModalContext'
import { ButtonSubmit, Container, Content, Title } from '../../GlobalStyle'
import api from '../../hooks/API'
import BoxShadow from '../components/BoxShadowDiv'
import Header from '../components/Header'
import ModalImport from '../components/Modal/ModalImport'
import { Description, DescriptionImport, ImportButton, Imports, TitleImport } from './style'
const Import = () => {
  const { openModal, setOpenModal } = useContext(ModalTotalContext)
  const { data: fixed, isLoading } = useQuery(['fixed'], () => api.getFixedExpenses())
  const { data: variable } = useQuery(['methdosSales'], () => api.getMethodsSales())
  const [type, setType] = useState()

  const handleModal = (type) => {
    setType(type)
    setOpenModal('upload')
  }

  if (isLoading) return <div></div>
  return (
    <>
      <Content>
        <Title>Importar dados</Title>

        <BoxShadow overflow={'initial'}>
          <Header title={'Importar por planilha'} />
          <Container>
            <Description>
              Importe arquivo EXCEL contendo dados para alimentar o sistema.
            </Description>
            <Imports>
              <ImportButton>
                <div>
                  <TitleImport>
                    <span>
                      <TbCoins />
                      Despesas Fixas
                    </span>
                  </TitleImport>

                  <DescriptionImport>
                    Faça a importação de sua planilha de despesas fixas no formato Excel
                  </DescriptionImport>
                </div>

                <ButtonSubmit medium width={'200px'} onClick={() => handleModal('fixed')}>
                  <HiOutlineUpload /> Importar novo
                </ButtonSubmit>
              </ImportButton>

              <ImportButton>
                <div>
                  <TitleImport>
                    <span>
                      <TbCoins />
                      Despesas Variáveis
                    </span>
                  </TitleImport>

                  <DescriptionImport>
                    Faça a importação de sua planilha de despesas variáveis no formato Excel
                  </DescriptionImport>
                </div>

                <ButtonSubmit medium width={'200px'} onClick={() => handleModal('variable')}>
                  <HiOutlineUpload /> Importar novo
                </ButtonSubmit>
              </ImportButton>

              <ImportButton>
                <div>
                  <TitleImport>
                    <span>
                      <BiPurchaseTagAlt />
                      Compras
                    </span>
                  </TitleImport>

                  <DescriptionImport>
                    Faça a importação de sua planilha de compras no formato Excel
                  </DescriptionImport>
                </div>

                <ButtonSubmit medium width={'200px'} onClick={() => handleModal('products')}>
                  <HiOutlineUpload /> Importar novo
                </ButtonSubmit>
              </ImportButton>

              <ImportButton>
                <div>
                  <TitleImport>
                    <span>
                      <BiPurchaseTagAlt />
                      Vendas
                    </span>
                  </TitleImport>

                  <DescriptionImport>
                    Faça a importação de sua planilha de vendas no formato Excel
                  </DescriptionImport>
                </div>

                <ButtonSubmit medium width={'200px'}>
                  <HiOutlineUpload /> Importar novo
                </ButtonSubmit>
              </ImportButton>
            </Imports>
          </Container>
        </BoxShadow>
      </Content>
      {openModal == 'upload' && <ModalImport type={type} data={{ fixed, variable }} />}
    </>
  )
}
export default Import
